import React, { useState, useEffect } from 'react'
import { MarkdownViewer, LoadingFull } from '@arnsbogroup/react-voicearchive'

const AnnouncementDetails = ({ resourceId = null }) => {
  const [loading, setLoading] = useState(true)
  const [announcement, setAnnouncement] = useState(null)

  useEffect(() => {
    if (resourceId) {
      loadAnnouncement()
    }
  }, [resourceId])

  const loadAnnouncement = async () => {
    setLoading(true)
    try {
      const { success, data } = await fetch(`/rest/v2/announcement/${resourceId}`).then(r => r.json())
      if (!success || !data) {
        return
      }
      setAnnouncement(data || null)
    } catch (e) {
      toastr.error(e)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <LoadingFull />
  }

  return (
    <MarkdownViewer>
      {announcement?.body}
    </MarkdownViewer>
  )
}

export default AnnouncementDetails
